import {createListenerMiddleware} from "@reduxjs/toolkit";
import * as lscache from "lscache";

import {HOME_MATCH_PENDING_PREFERENCES_KEY} from "../../app/constants/storage_keys";
import {notifyBugsnag} from "../../errors/bugsnag/notify_bugsnag";
import {IClientUpdatePayload} from "../../for_you/api/for_you_client";
import type {IRootState} from "../../store/store";
import {getUserProfileApi} from "../../user/api/get_user_profile";

export const surveyPreferencesActionListener = createListenerMiddleware<IRootState>();

surveyPreferencesActionListener.startListening({
    matcher: getUserProfileApi.endpoints.getUserProfile.matchFulfilled,
    effect: async (action, listenerApi) => {
        const userProfile = action.payload;
        if (!userProfile) {
            return;
        }

        // Check if there are pending preferences to sync
        const postData: IClientUpdatePayload | null = lscache.get(HOME_MATCH_PENDING_PREFERENCES_KEY);
        if (!postData) {
            return;
        }

        const hasAnyPreferences = postData.rooms || postData.price || (postData.regions && postData.regions.length > 0);
        if (hasAnyPreferences) {
            try {
                const {forYouClient} = await import("../../for_you/api/for_you_client");
                await listenerApi.dispatch(forYouClient.endpoints.updateForYouClient.initiate(postData)).unwrap();

                lscache.remove(HOME_MATCH_PENDING_PREFERENCES_KEY);
            } catch (error) {
                notifyBugsnag(error, "Failed to sync pending preferences to API", {postData});
            }
        }
    }
});
import {createListenerMiddleware} from "@reduxjs/toolkit";
import * as lscache from "lscache";

import {HOME_MATCH_PENDING_PREFERENCES_KEY} from "../../app/constants/storage_keys";
import {notifyBugsnag} from "../../errors/bugsnag/notify_bugsnag";
import {IClientUpdatePayload} from "../../for_you/api/for_you_client";
import type {IRootState} from "../../store/store";
import {getUserProfileApi} from "../../user/api/get_user_profile";

export const surveyPreferencesActionListener = createListenerMiddleware<IRootState>();

surveyPreferencesActionListener.startListening({
    matcher: getUserProfileApi.endpoints.getUserProfile.matchFulfilled,
    effect: async (action, listenerApi) => {
        const userProfile = action.payload;
        if (!userProfile) {
            return;
        }

        // Check if there are pending preferences to sync
        const postData: IClientUpdatePayload | null = lscache.get(HOME_MATCH_PENDING_PREFERENCES_KEY);
        if (!postData) {
            return;
        }

        const hasAnyPreferences = postData.rooms || postData.price || (postData.regions && postData.regions.length > 0);
        if (hasAnyPreferences) {
            try {
                const {forYouClient} = await import("../../for_you/api/for_you_client");
                await listenerApi.dispatch(forYouClient.endpoints.updateForYouClient.initiate(postData)).unwrap();

                lscache.remove(HOME_MATCH_PENDING_PREFERENCES_KEY);
            } catch (error) {
                notifyBugsnag(error, "Failed to sync pending preferences to API", {postData});
            }
        }
    }
});
